export enum SOCIAL_NETWORKS {
    /**
     * @value %PLATFORM% now activated
     */
    ACTIVATION_SUCCESS = 'FRONT.SOCIAL_ADVOCACY.SOCIAL_PLATFORM.ACTIVATION_SUCCESS',
    /**
     * @value Client ID
     */
    CLIENT_ID_PLACEHOLDER = 'FRONT.SOCIAL_ADVOCACY.SOCIAL_PLATFORM.CLIENT_ID_PLACEHOLDER',
    /**
     * @value Client secret
     */
    CLIENT_SECRET_PLACEHOLDER = 'FRONT.SOCIAL_ADVOCACY.SOCIAL_PLATFORM.CLIENT_SECRET_PLACEHOLDER',
    /**
     * @value Connecting LumApps to %PLATFORM% with a custom app requires authentication. Use an existing app or create one. Learn more on the <a href="https://docs.lumapps.com/docs/knowledge-l06615641805303718" target="_blank">help site</a>.
     */
    CUSTOM_APP_HELPER = 'FRONT.SOCIAL_ADVOCACY.SOCIAL_PLATFORM.CUSTOM_APP_HELPER',
    /**
     * @value Use custom %PLATFORM% app
     */
    CUSTOM_APP_TITLE = 'FRONT.SOCIAL_ADVOCACY.SOCIAL_PLATFORM.CUSTOM_APP_TITLE',
    /**
     * @value Social advocacy users will not be able to share content on %PLATFORM% until it is re-activated.
     * Are you sure you want to proceed?
     */
    DEACTIVATE_CONFIRM_DESCRIPTION = 'FRONT.SOCIAL_ADVOCACY.SOCIAL_PLATFORM.DEACTIVATE_CONFIRM_DESCRIPTION',
    /**
     * @value Deactivate %PLATFORM%
     */
    DEACTIVATE_CONFIRM_TITLE = 'FRONT.SOCIAL_ADVOCACY.SOCIAL_PLATFORM.DEACTIVATE_CONFIRM_TITLE',
    /**
     * @value %PLATFORM% is the only social network activated.
     * Social advocacy users will not be able to share until a social network is re-activated.
     * Are you sure you want to proceed?
     */
    DEACTIVATE_LAST_CONFIRM_DESCRIPTION = 'FRONT.SOCIAL_ADVOCACY.SOCIAL_PLATFORM.DEACTIVATE_LAST_CONFIRM_DESCRIPTION',
    /**
     * @value Deactivate %PLATFORM%
     */
    DEACTIVATE_LAST_CONFIRM_TITLE = 'FRONT.SOCIAL_ADVOCACY.SOCIAL_PLATFORM.DEACTIVATE_LAST_CONFIRM_TITLE',
    /**
     * @value %PLATFORM% now deactivated
     */
    DEACTIVATION_SUCCESS = 'FRONT.SOCIAL_ADVOCACY.SOCIAL_PLATFORM.DEACTIVATION_SUCCESS',
    /**
     * @value You will not be able to share content on %PLATFORM% until you sign back in. Are you sure you want to disconnect?
     */
    DISCONNECT_CONFIRM_DESCRIPTION = 'FRONT.SOCIAL_ADVOCACY.SOCIAL_PROFILE.DISCONNECT.CONFIRM_DESCRIPTION',
    /**
     * @value Disconnect from %PLATFORM%
     */
    DISCONNECT_CONFIRM_TITLE = 'FRONT.SOCIAL_ADVOCACY.SOCIAL_PROFILE.DISCONNECT.CONFIRM_TITLE',
    /**
     * @value Your %PLATFORM% profile is now disconnected.
     */
    DISCONNECT_NOTIFICATION = 'FRONT.SOCIAL_ADVOCACY.SOCIAL_PROFILE.DISCONNECT.NOTIFICATION',
    /**
     * @value Only <strong>Global administrators</strong> can activate Social networks in the <strong>Social networks</strong> admin section. <br/>
     * This step can be completed later.
     */
    EMPTY_HELP = 'FRONT.SOCIAL_ADVOCACY.PROGRAM_CREATION.SOCIAL_NETWORKS.EMPTY_HELP',
    /**
     * @value There are no Social networks activated.
     */
    NOT_ACTIVATED = 'FRONT.SOCIAL_ADVOCACY.SOCIAL_NETWORKS.NO_ACTIVATED',
    /**
     * @value There is no social platform activated.
     */
    NO_ACTIVE_NETWORK = 'FRONT.SOCIAL_ADVOCACY.SOCIAL_PROFILE.NO_ACTIVE_NETWORK',
    /**
     * @value Share content to your %PLATFORM% account
     * @description Text to be used besides a social platform in order to provide context on what will happen if a user connects to that platform
     */
    SHARE_CONTENT_ON_PLATFORM = 'SOCIAL_ADVOCACY.SHARE_CONTENT_ON_PLATFORM',
    /**
     * @value Social Networks
     */
    SOCIAL_NETWORK = 'ADMIN.NAV.SOCIAL_ADVOCACY.SOCIAL.NETWORK',
    /**
     * @value Activate %PLATFORM%
     */
    SOCIAL_PLATFORM_ACTIVATE = 'FRONT.SOCIAL_ADVOCACY.SOCIAL_PLATFORM_ACTIVATE',
    /**
     * @value Activated
     */
    SOCIAL_PLATFORM_ACTIVATED = 'FRONT.SOCIAL_ADVOCACY.SOCIAL_PLATFORM_ACTIVATED',
    /**
     * @value Connect %PLATFORM%
     */
    SOCIAL_PLATFORM_CONNECT = 'FRONT.SOCIAL_ADVOCACY.SOCIAL_PLATFORM_CONNECT',
    /**
     * @value Deactivate %PLATFORM%
     */
    SOCIAL_PLATFORM_DEACTIVATE = 'FRONT.SOCIAL_ADVOCACY.SOCIAL_PLATFORM_DEACTIVATE',
    /**
     * @value Disconnect %PLATFORM%
     */
    SOCIAL_PLATFORM_DISCONNECT = 'FRONT.SOCIAL_ADVOCACY.SOCIAL_PLATFORM_DISCONNECT',
    /**
     * @value Deactivated
     */
    SOCIAL_PLATFORM_NOT_ACTIVATED = 'FRONT.SOCIAL_ADVOCACY.SOCIAL_PLATFORM_NOT_ACTIVATED',
    /**
     * @value Not connected
     */
    SOCIAL_PLATFORM_NOT_CONNECTED = 'FRONT.SOCIAL_ADVOCACY.SOCIAL_PLATFORM_NOT_CONNECTED',
    /**
     * @value Manage your social media profiles, allowing you to easily share content on social media.
     */
    SOCIAL_PROFILE_DESCRIPTION = 'FRONT.SOCIAL_ADVOCACY.SOCIAL_PROFILE.DESCRIPTION',
    /**
     * @value Social media profiles
     */
    SOCIAL_PROFILE_TITLE = 'FRONT.SOCIAL_ADVOCACY.SOCIAL_PROFILE.TITLE',
    /**
     * @value Activate custom app
     */
    SUBMIT_CUSTOM_APP = 'FRONT.SOCIAL_ADVOCACY.SOCIAL_PLATFORM.SUBMIT_CUSTOM_APP',
    /**
     * @value Switching between custom and default app may temporarily disable analytics data recording.
     * Are you sure you want to proceed?
     */
    SWITCH_APP_CONFIRM_DESCRIPTION = 'FRONT.SOCIAL_ADVOCACY.SOCIAL_PLATFORM.SWITCH_APP_CONFIRM_DESCRIPTION',
    /**
     * @value App switch
     */
    SWITCH_APP_CONFIRM_TITLE = 'FRONT.SOCIAL_ADVOCACY.SOCIAL_PLATFORM.SWITCH_APP_CONFIRM_TITLE',
    /**
     * @value Use custom app
     */
    USE_CUSTOM = 'FRONT.SOCIAL_ADVOCACY.SOCIAL_PLATFORM.USE_CUSTOM',
    /**
     * @value Use default app
     */
    USE_DEFAULT = 'FRONT.SOCIAL_ADVOCACY.SOCIAL_PLATFORM.USE_DEFAULT',
}
